import Typography from "@mui/material/Typography";


export interface PageTitleProps {
    title: string;
}

export default function PageTitle({title}: Readonly<PageTitleProps>) {
    return (
        <Typography variant={"h6"}>
            {title}
        </Typography>
    );
}